import styled from 'styled-components'
import { rem } from 'polished'

export const VerticalSideLine = styled.div`
  position: absolute;
  top: 0;
  width: 1px;
  z-index: 0;
  pointer-events: none;
  /* Center of the 20px ItemPin on mobile */
  left: ${rem(10)};
  
  @container (min-width: 640px) {
    /* Center of the 28px ItemPin on desktop */
    left: ${rem(14)};
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 100%;
    border-left: 1px dashed ${props => props.theme.palette.neutral.default.five};
  }
`
